import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import * as Chart from 'chart.js';
import * as jsPDF from 'jspdf';
import { Observable } from 'rxjs';
import { RestService } from '../rest.service';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es';

@Component({
  selector: 'app-direccion-unique',
  templateUrl: './direccion-unique.component.html',
  styleUrls: ['./direccion-unique.component.scss']
})
export class DireccionUniqueComponent implements OnInit {

  @ViewChild('content',{static: false}) content: ElementRef;

  _fecha = new Date();

  private intervalUpdate: any = null;
  chart1; chart2; chart3; chart4; chart5;
  chart6; chart7; chart8; chart9; chart10; chart11;

  items: Array<any> = [];
  date: string = new Date().toISOString().slice(0, 10);
  date_comparativa: string = new Date().toISOString().slice(0, 10);
  point: any = [];

  dateTime: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'd-m-Y',
    locale: Spanish,
    onClose: (selectedDates, dateStr, instance) => this.date = dateStr
  };

  constructor(public rest: RestService) { this.getPoints(); }

  ngOnInit() {
    this.chart1 = this.mixedChart('mix1', 'Navas-Bingo Electronico');
    this.getPoints();
  }

  private mixedChart(nombre, textTitle) {
    return new Chart(document.getElementById(nombre), {
      type: 'bar',
      data: {
        labels: [],
        datasets: [
          {
            label: 'Zitro-Jugado',
            type: 'line',
            borderColor: '#e2001a',
            data: [],
            fill: false
          },
          {
            label: 'Zitro-Acumulado',
            type: 'line',
            borderColor: '#e2001a',
            data: [],
            fill: false
          },
          {
            label: 'ZitroAA-Jugado',
            type: 'line',
            borderColor: 'tomato',
            data: [],
            fill: false
          },
          {
            label: 'ZitroAA-Acumulado',
            type: 'line',
            borderColor: 'tomato',
            data: [],
            fill: false
          },
          {
            label: 'Azul-Jugado',
            type: 'line',
            borderColor: '#0071bc',
            data: [],
            fill: false
          },
          {
            label: 'Azul-Acumulado',
            type: 'line',
            borderColor: '#0071bc',
            data: [],
            fill: false
          },
          {
            label: 'AzulAA-Jugado',
            type: 'line',
            borderColor: '#4b96c7',
            data: [],
            fill: false
          },
          {
            label: 'AzulAA-Acumulado',
            type: 'line',
            borderColor: '#4b96c7',
            data: [],
            fill: false
          }
        ]
      },
      options: {
        title: {
          display: true,
          text: textTitle
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        events: ['click'],
        legend: { display: true },
        maintainAspectRatio: true,
        responsive: true
      }
    });
  }

  restAux(chart, sala, operador, fecha, index1, index2) {

    this.rest.getKPI(sala, operador, fecha).subscribe((data) => {
      const label: any = [];
      const data1: any = [];
      const data2: any = [];

      for (let index = 0; index < data['data'].length; index++) {
        label.push(data['data'][index]['rango']);
        data1.push(data['data'][index]['jugado']);

        if (index > 0 && data['data'][index]['acumulado'] < 0.01) {
          data['data'][index]['acumulado'] = data['data'][index - 1]['acumulado'];
          data2.push(data['data'][index]['acumulado']);
        } else {
          data2.push(data['data'][index]['acumulado']);
        }
      }

      chart.data.labels = label;
      chart.data.datasets[index1].data = data1;
      chart.data.datasets[index2].data = data2;
      chart.update();
    });
  }

  getPoints() {

    this.restAux(this.chart1, 21, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart1, 21, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart1, 21, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart1, 21, 'DEGESTEC', this.date_comparativa, 6, 7);

    this.restAux(this.chart2, 17, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart2, 17, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart2, 17, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart2, 17, 'DEGESTEC', this.date_comparativa, 6, 7);

    this.restAux(this.chart3, 22, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart3, 22, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart3, 22, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart3, 22, 'DEGESTEC', this.date_comparativa, 6, 7);

    this.restAux(this.chart4, 20, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart4, 20, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart4, 20, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart4, 20, 'DEGESTEC', this.date_comparativa, 6, 7);

    this.restAux(this.chart5, 1, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart5, 1, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart5, 1, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart5, 1, 'DEGESTEC', this.date_comparativa, 6, 7);

    this.restAux(this.chart6, 2, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart6, 2, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart6, 2, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart6, 2, 'DEGESTEC', this.date_comparativa, 6, 7);

    this.restAux(this.chart7, 3, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart7, 3, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart7, 3, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart7, 3, 'DEGESTEC', this.date_comparativa, 6, 7);

    this.restAux(this.chart8, 4, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart8, 4, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart8, 4, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart8, 4, 'DEGESTEC', this.date_comparativa, 6, 7);

    this.restAux(this.chart9, 5, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart9, 5, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart9, 5, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart9, 5, 'DEGESTEC', this.date_comparativa, 6, 7);

  }

  destroyAndBuild() {
    if (this.chart1) { this.chart1.destroy(); }
    this.chart1 = this.mixedChart('mix1', 'Navas-Bingo Electronico');

    this.getPoints();
  }

  anadir_cup(value) {
    this.chart1.push(value);

    if (this.chart1) { this.chart1.destroy(); }

    // Chart 1
    const c1l1: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c1l2: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c1l3: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c1b1: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c1b2: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c1b3: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    // Chart 9
    const c9l1: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c9l2: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c9l3: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c9b1: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c9b2: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const c9b3: any = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

    // Chart 1
    for (let jindex = 0; jindex < this.chart1.length; jindex++) {
      for (let i = 0; i < 7; i++) {
        c1l1[i] = c1l1[i] + this.chart1[jindex]['graficas'][0]['data'][i]['consumoAcumAA'];
        c1l2[i] = c1l2[i] + this.chart1[jindex]['graficas'][0]['data'][i]['consumoAcum'];
        c1l3[i] = c1l3[i] + this.chart1[jindex]['graficas'][0]['data'][i]['ahorroAcum'];
        c1b1[i] = c1b1[i] + this.chart1[jindex]['graficas'][0]['data'][i]['consumoAA'];
        c1b2[i] = c1b2[i] + this.chart1[jindex]['graficas'][0]['data'][i]['consumo'];
        c1b3[i] = c1b3[i] + this.chart1[jindex]['graficas'][0]['data'][i]['ahorro'];
      }
    }

    // Chart 9
    for (let jindex1 = 0; jindex1 < this.chart1.length; jindex1++) {
      for (let i2 = 0; i2 < 7; i2++) {
        c9l1[i2] = c9l1[i2] + this.chart1[jindex1]['graficas'][8]['data'][i2]['consumoAcumAA'];
        c9l2[i2] = c9l2[i2] + this.chart1[jindex1]['graficas'][8]['data'][i2]['consumoAcum'];
        c9l3[i2] = c9l3[i2] + this.chart1[jindex1]['graficas'][8]['data'][i2]['ahorroAcum'];
        c9b1[i2] = c9b1[i2] + this.chart1[jindex1]['graficas'][8]['data'][i2]['consumoAA'];
        c9b2[i2] = c9b2[i2] + this.chart1[jindex1]['graficas'][8]['data'][i2]['consumo'];
        c9b3[i2] = c9b3[i2] + this.chart1[jindex1]['graficas'][8]['data'][i2]['ahorro'];
      }
    }

    // this.chart1 = this.mixedChart('mix1', c1l1, c1l2, c1l3, c1b1, c1b2, c1b3, 'Evolucion termino factura total');
  }



}
